import {
  CircularProgress,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import { useCardSincronizacaoStyles } from "./card-sincronizacao-styles";
import { formatDataHora } from "../../../../utils/format-data-hora";
import { CardSincronizacaoProps } from "./card-sincronizacao-props";
import { useCadastros } from "../../../../service/app/providers/cadastros-provider";
import { DownloadIcon } from "../../icons/download-icon";
import { useThemeQueries } from "../../../../theme";
import { alterarNomeSituacao } from "../../../../utils/alterar-nome-situacao";
import { alterarCorStatusSituacao } from "../../../../utils/alterar-cor-situacao";
import { useCallback } from "react";
import { useToastSaurus } from "../../../../service/app/use-cases";
import { useGetSincronizacaoDadosById } from "../../../../data/api/gestao/sincronizacao-dados/get-sincronizacao-dados-by-id";
import { toDecimalString } from "../../../../utils/to-decimal";
import { isNumber } from "lodash";
import classNames from "classnames";
import saveAs from "file-saver";

export const CardSincronizacao = ({
  model,
  lojaId,
  index,
}: CardSincronizacaoProps) => {
  const classes = useCardSincronizacaoStyles();
  const { abrirEnvioCarga } = useCadastros();
  const { showToast } = useToastSaurus();
  const { theme, isMobile } = useThemeQueries();
  const { carregando, getSincronizacaoDadosById } = useGetSincronizacaoDadosById();

  const handleDownload = useCallback(async (e?: any) => {
    if (e && e.stopPropagation) e.stopPropagation();
    if (carregando) return

    try {
      const ret = await getSincronizacaoDadosById(lojaId, model.id, 4);
      if (ret.erro) throw ret.erro;

      if (!ret.resultado) {
        showToast("error", "Modelo Inválido");
        return;
      }

      const data = ret.resultado.data;
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      saveAs(blob, `download-${model.id}.json`);
    } catch (err: any) {
      showToast("error", err?.message ?? String(err));
    }
  }, [carregando, getSincronizacaoDadosById, lojaId, model.id, showToast]);

  return (
    <>
      {isMobile ? (
        <TableRow onClick={() => abrirEnvioCarga(lojaId, model.id, '/sincronizao', true)}
          className={classNames(index % 2 === 0 && classes.cardCinza, classes.card)}>
          <TableCell
            color="#fff"
            scope="row"
            align='center'
          >
            {model.aplicacao}
          </TableCell>
          <TableCell align='center'>
            {model.usuario}
          </TableCell>
          <TableCell align='center'>
            {(model.totalProdutos)}
          </TableCell>
          {isNumber(model?.porcentagem) ? (
            <TableCell align='center'>{model?.porcentagem}%</TableCell>
          ) : (
            <TableCell align='center'>Sem porcentagem</TableCell>
          )}
          <TableCell align='center'>
            <Typography>
              {formatDataHora(new Date(model.dataCriacao))}
            </Typography>
          </TableCell>
          <TableCell align='center'>
            <Typography>
              {formatDataHora(new Date(model.ultimoEnvio))}
            </Typography>
          </TableCell>
          <TableCell align='center'>
            <Typography
              className={classes.titleStatus}
              style={{
                background: alterarCorStatusSituacao(model.situacao),
              }}
            >
              {alterarNomeSituacao(model.situacao)}
            </Typography>
          </TableCell>
          <TableCell align='center'>
            <div
              onClick={handleDownload}>
              {carregando ? <CircularProgress /> : (
                <DownloadIcon
                  tipo="BUTTON"
                />
              )}
            </div>
          </TableCell>
        </TableRow>
      ) : (

        <TableRow
          onClick={() => abrirEnvioCarga(lojaId, model.id, '/sincronizacao', true)}
          className={classNames(index % 2 === 0 && classes.cardCinza, classes.card)}
        >

          <TableCell
            color="#fff"
            scope="row"
            size="small"
            align='center'
          >
            {model.aplicacao}
          </TableCell>
          <TableCell align='center'>
            {model.usuario}
          </TableCell>
          <TableCell align='center'>
            {toDecimalString(model.totalProdutos, 0)}
          </TableCell>
          {isNumber(model?.porcentagem) ? (
            <TableCell align='center'>{model?.porcentagem}%</TableCell>
          ) : (
            <TableCell align='center'>Sem porcentagem</TableCell>
          )}
          <TableCell align='center'>
            <Typography>
              {formatDataHora(new Date(model.dataCriacao))}
            </Typography>
          </TableCell>
          <TableCell align='center'>
            <Typography>
              {formatDataHora(new Date(model.ultimoEnvio))}
            </Typography>
          </TableCell>
          <TableCell align='center'>
            <Typography
              className={classes.titleStatus}
              style={{
                background: alterarCorStatusSituacao(model.situacao),
                padding: theme.spacing(1),
              }}
            >
              {alterarNomeSituacao(model.situacao)}
            </Typography>
          </TableCell>
          <TableCell width="6%" align="center">
            <div
              onClick={handleDownload}>
              {carregando ? <CircularProgress /> : (
                <DownloadIcon
                  tipo="BUTTON"
                />
              )}
            </div>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};
